/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable import/no-cycle */
import ajax from '../../../../scanline/utils/ajax';
import { hasAccessToken } from '../../../../scanline/utils/token';

const LIMIT = 500;
const ACTIVE_BATCH_LIMIT = 10;

const _fetchList = async ({ offset = 0, limit = LIMIT } = {}) => {
	console.log(`offset: ${offset}, limit: ${limit}`);
	return new Promise((resolve, reject) => {
		if (hasAccessToken()) {
			const _callback = (err, res) => {
				if (err) {
					reject(err);
				} else {
					const { count, reports } = res;
					resolve({ count, reports });
				}
			};

			ajax(
				`/actionPlanClosureReport`,
				JSON.stringify({ offset, limit }),
				'POST',
				_callback,
				false,
				'dataIntegrity'
			);
		} else {
			// eslint-disable-next-line prefer-promise-reject-errors
			reject('User session expired');
		}
	})
}

const nextBatch = async (state) => {

	if (state.count <= state.receivedCount) {
		return state;
	}

	state.activeRequests += 1;
	state.offset += LIMIT;
	state.remainingBatchesCount -= 1;
	const offset = state.offset;
	const { reports: itemsBatch } = await _fetchList({ offset, limit: LIMIT});
	state.activeRequests -= 1;
	state.receivedCount += (itemsBatch || []).length;
	state.itemsBatched.push(itemsBatch);

	if (state.remainingBatchesCount > 0) {
		return nextBatch(state);
	}

	return state;
}

export const listActionPlanClosureReports = async () => {
	const state = {
		count: undefined,
		receivedCount: undefined,
		offset: 0,
		limit: LIMIT,
		activeRequests: 1,
		itemsBatched: [],
		remainingBatchesCount: undefined,
	}

	// first batch and count
	const firstBatchResponse = await _fetchList({ offset: state.offset, LIMIT});
	const { count, reports: firstBatchItems } = firstBatchResponse;
	state.activeRequests -= 1;
	state.count = count;
	state.receivedCount = (firstBatchItems || []).length;
	state.itemsBatched.push(firstBatchItems);

	// additional batches
	if (count > ((firstBatchItems || []).length && firstBatchItems.length > 0)) {
		state.remainingBatchesCount = Math.ceil((count - firstBatchItems.length)/LIMIT);
		const startingBatchCount = Math.min(state.remainingBatchesCount, ACTIVE_BATCH_LIMIT);

		const requests = [];
		while(requests.length < startingBatchCount) {
			requests.push(nextBatch(state));
		}

		await Promise.all(requests);
	}

	return state.itemsBatched.flat();
};

const _exports = {
	listActionPlanClosureReports
};

export default {
	..._exports
};
